/* eslint-disable camelcase */
import { useMutation, useQueryCache } from 'react-query';
import { client } from 'utils/api-client';

export function useUpdateRecordOfService(staffId: string, service_id: string) {
  const cache = useQueryCache();
  return useMutation(
    (values: any) =>
      client(`employees/service-history/${service_id}/`, {
        data: values,
        method: 'PATCH',
      }).then((res) => res),
    {
      onSuccess: () => {
        cache.invalidateQueries(['employee-data', staffId]);
      },
    }
  );
}
